import { useEffect, useRef, useState } from "react";
import { NAVY, WHITE } from "../styles/palette";
import { MyRoutePanel } from "./MyRoutePanel";
import { useIsMobile } from "../lib/useIsMobile";

export function TechView({ techId, technicians, clients, pricing, onLogout, orgName }) {
  const isMobile = useIsMobile();
  const tech = technicians?.find(t=>t.id===techId);

  // The technician view is mounted by App.js WITHOUT its toast plumbing, so every
  // "Job started" / "Skip failed" / "Photo upload failed" message from MyRoutePanel used
  // to be swallowed by a no-op — a tech whose PATCH was rejected saw nothing and assumed
  // it worked. Own the toast here (same look as App.js: .alert, 3.5s).
  const [toast, setToast] = useState(null);
  const toastTimer = useRef(null);
  const showToast = (msg, type="success") => {
    setToast({msg, type});
    if (toastTimer.current) clearTimeout(toastTimer.current);
    toastTimer.current = setTimeout(()=>setToast(null), 3500);
  };
  useEffect(()=>()=>{ if (toastTimer.current) clearTimeout(toastTimer.current); }, []);

  return (
    <div style={{minHeight:"100vh",background:"#f5f6f8"}}>
      {/* Header */}
      <div style={{background:NAVY,padding:"14px 20px",display:"flex",alignItems:"center",justifyContent:"space-between",gap:10}}>
        <div style={{minWidth:0}}>
          <div style={{fontWeight:800,fontSize:16,color:WHITE,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{orgName || "Your company"}</div>
          <div style={{fontSize:12,color:"rgba(255,255,255,.5)",marginTop:2}}>👤 {tech?.name||"Technician"}</div>
        </div>
        <button onClick={onLogout} style={{background:"rgba(255,255,255,.1)",border:"1px solid rgba(255,255,255,.2)",color:"rgba(255,255,255,.7)",borderRadius:6,padding:isMobile?"10px 14px":"6px 12px",minHeight:isMobile?40:undefined,cursor:"pointer",fontFamily:"Inter,sans-serif",fontSize:isMobile?14:12,flexShrink:0}}>
          Sign out
        </button>
      </div>

      {/* Toast — fixed under the header so it is visible wherever the tech has scrolled. */}
      {toast && (
        <div style={{position:"fixed",top:"calc(12px + env(safe-area-inset-top))",left:12,right:12,zIndex:200,pointerEvents:"none",display:"flex",justifyContent:"center"}}>
          <div className={`alert alert-${toast.type}`} style={{margin:0,width:"100%",maxWidth:600,boxShadow:"var(--shadow-lg)",pointerEvents:"auto"}}>
            {toast.type==="success"?"✅":toast.type==="error"?"❌":"ℹ️"} {toast.msg}
          </div>
        </div>
      )}

      {/* Content */}
      <div style={{padding:16,maxWidth:600,margin:"0 auto"}}>
        <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:16}}>
          <div style={{flex:1}}>
            <div style={{fontWeight:700,fontSize:18,color:"#1a1f36"}}>My Route</div>
          </div>
        </div>
        <MyRoutePanel
          technicians={technicians}
          clients={clients}
          pricing={pricing}
          invoices={[]}
          serviceArea={{}}
          onRefresh={()=>{}}
          showToast={showToast}
          today={new Date()}
          selectedTechId={techId}
          techScoped={true}
        />
      </div>
    </div>
  );
}
